export default __webpack_public_path__ + "img/homepage.product.05.asset.ef2d1849.jpg";